<template>
  <div class="header">
    <img src="../assets/logo.png" class="logo"/>
    <nav>
      <div
        v-for="item in navList"
        :key="item.value"
        class="nav-item"
      >
        <div
          :class="routerPath === item.path ? 'item active' : 'item'"
          @click="jump(item)"
        >
          <div>{{ item.label }}</div>
          <span></span>
        </div>
      </div>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'header.vue',
  data () {
    return {
      navList: [
        {label: '首页', path: '/', value: 0},
        // {label: '东方创科', path: 'https://www.df-ck.com/#/home', value: 1},
        // {label: 'Kids+', path: 'https://www.kidsplusclub.com/#/home', value: 2},
        {label: '联系我们', path: '/contactUs', value: 3}
      ],
      routerPath: ''
    }
  },
  created () {
    this.getPath()
  },
  watch: {
    '$route': 'getPath'
  },
  methods: {
    getPath () {
      this.routerPath = this.$route.path
      console.log(this.$route.path)
    },
    jump (row) {
      if (row.label === '东方创科') {
        return window.open(row.path, '_blank')
      }
      if (row.label === 'Kids+') {
        return window.open(row.path, '_blank')
      }
      this.$router.push(row.path)
    }
  }
}
</script>

<style scoped lang="scss">
.header{
  width: 100%;
  height: 85px;
  box-sizing: border-box;
  padding: 0 40px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: #fff;
  .logo{
    height: 65px;
  }
  nav{
    display: flex;
    align-items: center;
    .nav-item{
      margin: 0 20px;
      .item{
        font-size: 15px;
        color: #565656;
        display: flex;
        flex-direction: column;
        align-items: center;
        div{
          padding: 7px 0;
        }
        span{
          height: 1px;
          width: 0;
          box-sizing: border-box;
          margin: 5px 0 0 0;
          background-color: #0099ff;
          transition: width 0.3s;
        }
        &:hover{
          cursor: pointer;
          color: #0099ff;
          span{
            width: 95%;
          }
        }
        &.active{
          cursor: pointer;
          color: #0099ff;
          span{
            width: 95%;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/header.vue